import * as Yup from "yup";
import { MESSAGE } from "./validationMessage";
import {
  EMAIL_REGEX,
  MOBILE_REGEX,
  NOSPACE_REGEX,
  PASSWORDS_REGEX,
} from "./constants";

export let email = Yup.string()
  .max(70, "Email must be no more than 70 characters")
  .required(MESSAGE.REQUIRED)
  .email(MESSAGE.EMAIL)
  .matches(EMAIL_REGEX, MESSAGE.EMAIL);

let name = Yup.string()
  .max(60, "Name should not be longer than 60 characters")
  .required(MESSAGE.REQUIRED)
  .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE);

let mobile = Yup.string().matches(MOBILE_REGEX, MESSAGE.PHONE);

export const CreatorAddSchema = Yup.object({
  name,
  email,
  mobile,
  password: Yup.string()
    .required(MESSAGE.REQUIRED)
    .matches(PASSWORDS_REGEX, MESSAGE.PASSWORD),
  cPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], MESSAGE.CPASSWORD)
    .required(MESSAGE.REQUIRED),
});
export const fantasyPointSchema = Yup.object().shape({
  action: Yup.string()
    .required("Action is required")
    .matches(
      /^[a-zA-Z0-9_]+$/,
      "Only letters, numbers and underscores allowed (no spaces or special characters)"
    )
    .test(
      "no-empty",
      "Action cannot be empty",
      (value) => value && value.trim().length > 0
    ),

  points: Yup.number()
    .required("Points are required")
    .positive("Points must be positive")
    .min(1, "Points must be at least 1")
    .max(100, "Points cannot exceed 100")
    .integer("Points must be a whole number"),

  description: Yup.string()
    .required("Description is required")

    .test(
      "no-empty",
      "Description cannot be empty",
      (value) => value && value.trim().length > 0
    ),

  conditions: Yup.array()
    .of(
      Yup.object().shape({
        key: Yup.string()
          .required("Key is required")
          .matches(
            /^[a-zA-Z_]+$/,
            "Only letters and underscores allowed (no numbers or special characters)"
          )
          .test(
            "no-empty",
            "Key cannot be empty",
            (value) => value && value.trim().length > 0
          ),

        value: Yup.string()
          .required("Value is required")
          .test(
            "no-empty",
            "Value cannot be empty",
            (value) => value && value.trim().length > 0
          ),
      })
    )
    .min(1, "At least one condition is required"),
});
export const adminSchema = Yup.object().shape({
  name: name,
  email: email,
  // phoneNumber: Yup.string()
  //   .required(MESSAGE.REQUIRED)
  //   .matches(MOBILE_REGEX, MESSAGE.PHONE),
});
export const userSchema = Yup.object({
  name: Yup.string()
    .trim("spaces not allowed")
    .strict(true)
    .required("Name is required")
    .test("not-only-spaces", "Name cannot be empty", value => !!value && value.trim().length > 0),

  email: Yup.string()
    .trim("spaces not allowed")
    .strict(true)
    .email("Enter a valid email")
    .required("Email is required"),

  phone: Yup.string()
    .matches(/^\d{10}$/, "Phone number must be exactly 10 digits")
    .required("Phone is required"),
});
export const subAdminSchema = Yup.object({
  name: name,
  email: email,
});

export const notificationSchema = Yup.object({
  
  title: Yup.string()
    .required('Title is required')
    .min(5, 'Title must be at least 5 characters')
    .max(50, 'Title must not exceed 50 characters'),
  content: Yup.string()
    .required('Content is required')
    .min(10, 'Content must be at least 10 characters')
    .max(500, 'Content must not exceed 500 characters'),

})

const prizeBreakupSchema = Yup.object().shape({
  position: Yup.string().required('Position is required'),
  amount: Yup.number().required('Amount is required').positive(),
});

const winningsSchema = Yup.object().shape({
  from: Yup.number().required('From is required').positive(),
  to: Yup.number().required('To is required').positive().min(
    Yup.ref('from'), 
    'To must be greater than or equal to From'
  ),
  price: Yup.number().required('Price is required').positive(),
});
export const conestmanagerSchema = Yup.object({
  match_id: Yup.number().required(MESSAGE.REQUIRED),
  name: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Only letters and spaces are allowed")
    .test(
      "not-empty-after-trim",
      (value) => value && value.trim().length > 0
    )
    .required(MESSAGE.REQUIRED),
  entry_fee: Yup.number()
    .typeError(MESSAGE.PRICE)
    .required(MESSAGE.PRICE)
    .min(0, "Must be a positive number"),

  total_spots: Yup.number()
    .typeError(MESSAGE.PRICE)
    .required(MESSAGE.PRICE)
    .min(1, "Must be at least 1"),

  total_prize_pool: Yup.number()
    .typeError(MESSAGE.PRICE)
    .required(MESSAGE.PRICE)
    .min(0, "Must be a positive number"),
  contest_type: Yup.string()
    .oneOf(["single", "multiple"], "Invalid contest type")
    .required(MESSAGE.REQUIRED),
  per_user_entry: Yup.number()
    .typeError(MESSAGE.PRICE)
    .required(MESSAGE.PRICE)
    .min(1, "Must be at least 1"),
  prize_breakup: Yup.array().of(prizeBreakupSchema).min(1),
  winnings: Yup.array().of(winningsSchema).min(1),
  start_time: Yup.date()
    .nullable()
    .required("Start time is required")
    .typeError("Invalid date"),
  end_time: Yup.date()
    .nullable()
    .required("End time is required")
    .min(Yup.ref("start_time"), "End time must be after start time")
    .typeError("Invalid date"),
  
});


export const howtoplaySchema = Yup.object({
  tab: Yup.string()
    .matches(/^[A-Za-z0-9\s]+$/, "Only letters, numbers and spaces are allowed")
    .test(
      "not-empty-after-trim",
      "Tab cannot be only spaces",
      (value) => value && value.trim().length > 0
    )
    .required(MESSAGE.REQUIRED),
});

export const languagemanagerSchema = Yup.object({
  language_type: Yup.string()
    .max(6, "Language type must not exceed 6 characters")
    .matches(
      /^[A-Za-z]+$/,
      "Only letters are allowed (no spaces, numbers, or special characters)"
    )
    .required("Language type is required"),

  name: Yup.string()
    .max(12, "Language name must not exceed 12 characters")
    .matches(
      /^[A-Za-z]+$/,
      "Only letters are allowed (no spaces, numbers, or special characters)"
    )
    .required("Language name is required"),
});

export const faqSchema = Yup.object({
  title: Yup.string().required(MESSAGE.REQUIRED),
  description: Yup.string().required(MESSAGE.REQUIRED),
});
export const CreatorEditSchema = Yup.object({
  question: Yup.string().required(MESSAGE.REQUIRED),
  slug: Yup.string().required(MESSAGE.REQUIRED),
});

export const EmailTemplateSchema = Yup.object({
  email: email,
  name: name,
});

export const CmsSchema = Yup.object({
  // title,
  // status,
  title: Yup.string()
    .min(2, "Tital must be longer than 2 characters")
    .max(100, "Tital should not be longer than 100 characters")
    .required(MESSAGE.REQUIRED)
    .matches(/^\S/, "Tital cannot start with a blank space"),
  slug: Yup.string()
    .max(30, "Slug should not be longer than 30 characters")
    .required(MESSAGE.REQUIRED)
    .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE),
});

export const bannerSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE)
    .min(2, "Name must be at least 2 characters")
    .max(200, "Name should not be longer than 200 characters"),
  startDate: Yup.date()
    .required("Start date is required")
    .min(new Date(), "Start date cannot be in the past"),
  endDate: Yup.date()
    .required("End date is required")
    .min(Yup.ref("startDate"), "End date must be after start date"),
  description: Yup.string()
    .required("Description is required")
    .min(10, "Description must be at least 10 characters")
    .max(500, "Description should not be longer than 500 characters"),
  image: Yup.mixed().required("Image is required"),
  tournamentId: Yup.string().required("Tournament ID is required"),
});

export const notificationTemplatesSchema = Yup.object().shape({
  title: Yup.string()
    .required("Name is required")
    .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE)
    .min(2, "Name must be at least 2 characters")
    .max(200, "Name should not be longer than 200 characters"),
  notification_type: Yup.string()
    .required("notification_type is required")
    .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE)
    .min(2, "notification_type must be at least 2 characters")
    .max(200, "notification_type should not be longer than 200 characters"),
  content: Yup.string().required(MESSAGE.REQUIRED),
});
